export default {
  restrictedClaimNames: [
    'newpassword',
    'reenterpassword',
    'webauthnchallenge',
    'webauthnrawid',
    'webauthnclientdatajson',
    'webauthnattestation',
    'webauthnrpid',
    'webauthnuserhandle',
    'webauthnsignature',
    'webauthnauthenticatordata',
    'webauthnhascredential',
    'webauthnavailable',
    'webauthndisplayname',
    'webauthnname',
    'webauthnrequireplatformauth',
    'EventTimestamp',
    'PolicyId',
    'CorrelationId',
    'Culture',
    'EventType',
  ],
  unsavedComponentCloseMsg: 'Looks like there are some unsaved changes. Are you sure to discard the unsaved data ?',
  feedbackSubmitUrl: 'https://iefeditorupload-functionapp20220930204814.azurewebsites.net/api/UserFeedback?session=',
  serverBaseUrl: 'https://iefeditorupload-functionapp20220930204814.azurewebsites.net/api/',
  emailPromptEnabled: true,
  displayableTypes: ['string', 'date', 'dateTime', 'boolean', 'duration', 'int', 'long'], // Types that can be shown in user input pages with readonly components
  subFlowTypes: {
    formSubmitAction: {
      id: 'formSubmitAction',
      displayName: 'submit action',
    },
    userInfoEndpoint: {
      id: 'userInfoEndpoint',
      displayName: 'user info endpoint',
    },
    emailVerificationSendAction: {
      id: 'emailVerificationSendAction',
      displayName: 'custom email verification',
    },
  },
  emailOTPTemplates: [
    {
      id: 'd-290c35bdc31548ab987801598c372101',
      name: 'OTP Login',
    },
    {
      id: 'd-fd6a1c8fd9f94c73a6db0cae7743478d',
      name: 'New Account Email Verification',
    },
    {
      id: 'd-a7b0593bff5d450792124d69709f9560',
      name: 'Password Reset',
    },
  ],
  customFieldResolvers: ['OAUTH-KV:'],
  defaultAppSettingFields: {
    tenantName: {
      id: 'tenantName',
      tooltip: 'The name of the B2C tenant the policy is deployed to.',
      readonly: true
    },
    Tenant: {
      id: 'Tenant',
      tooltip: 'The domain of the B2C tenant the policy is deployed to, such as tenantName.onmicrosoft.com',
      readonly: true
    },
    tenantId: {
      id: 'tenantId',
      tooltip: 'The object ID of the B2C tenant the policy is deployed to.',
      readonly: true
    },
    iefAppId: {
      id: 'iefAppId',
      tooltip: 'The application ID of the IEF application on the B2C tenant the policy is deployed to.',
      readonly: true
    },
    proxyIefAppId: {
      id: 'proxyIefAppId',
      tooltip: 'The application ID of the proxy IEF application on the B2C tenant the policy is deployed to.',
      readonly: true
    },
    extensionsContainerClientId: {
      id: 'extensionsContainerClientId',
      tooltip: 'The application/client ID of the B2C extensions container application. Required for AAD operations when custom AAD attributes are used.',
      readonly: true
    },
    extensionsContainerObjectId: {
      id: 'extensionsContainerObjectId',
      tooltip: 'The object ID of the B2C extensions container application. Required for AAD operations when custom AAD attributes are used.',
      readonly: true
    },
    tokenSigningKeyContainer: {
      id: 'tokenSigningKeyContainer',
      tooltip: 'The name of the policy key container containing the key to be used by the B2C tenant to sign tokens.',
      readonly: true
    },
    tokenEncryptionKeyContainer: {
      id: 'tokenEncryptionKeyContainer',
      tooltip: 'The name of the policy key container containing the key to be used by the B2C tenant to encrypt tokens.',
      readonly: true
    },
    SAMLCert: {
      id: 'SAMLCert',
      tooltip: 'The name of the policy key container containing the SAML certificate to be used by the B2C tenant when issuing SAML tokens.',
      readonly: true
    },
    oidcTestApplicationId: {
      id: 'oidcTestApplicationId',
      tooltip: 'The application ID of the app registration on the B2C tenant used for generating run-now links for OpenIDConnect policies.',
      readonly: true
    },
    applicationInsightsInstrumentationKey: {
      id: 'applicationInsightsInstrumentationKey',
      tooltip: 'The instrumentation key of the application insights instance to use with journey insights.',
      readonly: true
    },
    applicationInsightsClientEnabled: {
      id: 'applicationInsightsClientEnabled',
      tooltip: 'Enables the client mode of journey insights, which will send the client-side Application Insights script in the policy.',
      readonly: true
    },
    defaultSamlIssuerId: {
      id: 'defaultSamlIssuerId',
      tooltip: '',
      readonly: false
    }
  },
  enableGritSandboxDefaultEnv: true,
  enableGritDevEnvDefaultEnv: true,
  enableRestClientCertAuth: true,
  injectDevEnvWhenEnabled: false,
  defaultEnvMap: { 'enableGritSandboxDefaultEnv': 'GritSandbox', 'enableGritDevEnvDefaultEnv': 'gritDevTenant' },
  editorJsonSchemaVersion: '4',
  globalSessionId: '_SSO'
};
